function getLinkToNewGiftList(to) {
  switch (to) {
    case 'edit-gifts':
      return {
        type: 'route',
        dest: '/presentes/editar-lista',
      }
    case 'gifts-received':
      return {
        type: 'route',
        dest: '/presentes/recebidos',
      }
    case 'gifts-taxes':
      return {
        type: 'route',
        dest: '/presentes/configurar-lista',
      }
    case 'external-gifts':
      return {
        type: 'route',
        dest: '/presentes/listas-externas',
      }
    case 'about-gifts':
      return {
        type: 'route',
        dest: '/presentes/sobre-a-lista',
      }
    default:
      return false
  }
}

function getLinkToClassicGiftList(to) {
  switch (to) {
    case 'edit-gifts':
      return {
        type: 'link-wedsite',
        dest: '#/admin/presentes/lista',
      }
    case 'gifts-received':
      return {
        type: 'link-wedsite',
        dest: '#/admin/presentes/ganhados',
      }
    case 'gifts-taxes':
      return {
        type: 'link-wedsite',
        dest: '#/admin/presentes/taxas',
      }
    case 'external-gifts':
      return {
        type: 'link-wedsite',
        dest: '#/admin/presentes/externa',
      }
    case 'about-gifts':
      return {
        type: 'link-wedsite',
        dest: '#/admin/presentes/sobre',
      }
    default:
      return false
  }
}

export const getGiftListRoute = (to, wedSiteInfo) => {
  if (wedSiteInfo?.shared_menu?.gifts_edition_version === 'gifts-list-v2') {
    return getLinkToNewGiftList(to)
  }

  return getLinkToClassicGiftList(to)
}
